import AutoForm from "@/components/AutoForm";

export default {
  components: {
    AutoForm,
  },
  data() {
    // let validateComname = (rule, value, callback) => {
    //   var self = this;
    //   self.$http.post(self.url.VerifyCustomCompanyName, {
    //     Data: {
    //       CompanyName:value,
    //       CompanyId:self.form.Id
    //     }
    //   }).then(result => {
    //     if(!result){
    //       callback(new Error('企业名称已存在，换一个吧~'));
    //     }else{
    //       callback();
    //     }
    //   }, () => {
    //
    //   });
    // };
    // 银行卡号
    let validateBankcard2 = (rule,value,callback) => {
      if (!this.formChange.Account) {
        callback();
        // }
        // else if (!this.bankIsOk) {
        //   callback(new Error('您输入的银行卡号暂不支持！'));
      } else {
        validateBankcard(rule,value,callback);
      }
    };

    // 营业执照
    let validateBusinessLicense = (rule,value,callback) => {
      var reg = /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/;
      if (!this.formChange.BusinessLicense) {
        callback();
      } else if (!reg.test(value)) {
        callback(new Error("您输入正确的营业执照！"));
      } else {
        callback();
      }
    };

    // 法人
    let validateJuridicalPerson = (rule,value,callback) => {
      if (!this.formChange.JuridicalPerson) {
        callback();
      } else if (value.length > 5) {
        callback(new Error("长度不能超过 5 个字符"));
      } else {
        callback();
      }
    };

    // 税号
    let validateDutyParagraph = (rule,value,callback) => {
      var reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
      if (!this.formChange.DutyParagraph) {
        callback();
      } else if (!reg.test(value)) {
        callback(new Error("您输入正确的税号！"));
      } else {
        callback();
      }
    };

    function validatePhoneOrTel(rule,value,callback) {
      // let regex = /^((0[1-9]\d{1,2}[1-9]\d{6,7})|(1[3568947]\d{9})|(0[1-9]\d{1,2}1[3568479]\d{9}))$/gi;
      let regex = /^(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/;

      if (value != null && !regex.test(value)) {
        callback(new Error("请输入正确的企业号码"));
      } else {
        callback();
      }
    }

    // 电话
    let validatePhone2 = (rule,value,callback) => {
      var reg = /^((0\d{2,3}-\d{7,8})|(1[3567849]\d{9}))$/;
      if (!this.formChange.Phone) {
        callback();
      } else if (!reg.test(value)) {
        callback(new Error("您输入号码格式不正确或者位数不正确！"));
      } else {
        callback();
      }
      /*else {
        validatePhone(rule, value, callback);
      }*/
    };
    // 传真
    let validateFax = (rule,value,callback) => {
      if (!this.formChange.Fax) {
        callback();
      } else if (value.length > 20) {
        callback(new Error("长度不能超过 20 个字符"));
      } else {
        callback();
      }
    };
    // 邮编
    let validateZipCode = (rule,value,callback) => {
      if (!this.formChange.ZipCode) {
        callback();
      } else if (value.length > 50) {
        callback(new Error("长度不能超过 50 个字符"));
      } else {
        callback();
      }
    };
    // 证件号码格式验证
    let validateConfirmIdCard = (rule,value,callback) => {
      if (!this.formChange.ContactCardId) {
        callback();
      }
      switch (this.form.ContactCardType) {
        case 0: //
          validateIdCard(rule,value,callback);
          break;
        case 1:
          validatePassport(rule,value,callback);
          break;
        case 2:
          validateMilitaryCard(rule,value,callback);
          break;
        case 9:
          validateHMPassCard(rule,value,callback);
          break;
      }
    };
    // 联系人邮箱验证
    let validateContactsEmail = (rule,value,callback) => {
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (!this.formChange.ContactsEmail) {
        callback();
      } else if (!reg.test(value)) {
        callback(new Error("您输入邮箱格式不正确！"));
      } else {
        callback();
      }
    };
    return {

      form: {
        Name: "",SimpleName: "",
        EnglishName: "",Code: "",
        BusinessLicense: "",DutyParagraph: "",
        Adress: "",JuridicalPerson: "",
        Phone: "",Fax: "",
        ZipCode: "",Account: "",
        Bank: null,
        AccountBank: null,
        State: null,
        Id: "",
        Province: null,
        City: null,
        ContactsName: "",
        ContactsEmail: "",
        ContactCardId: "",
        ContactCardType: 0,
        OnlyBusinessLicense: "",
        BusinessLicenseTime: "2099-12-31",
        AccountBankTime: "",
        BusinessLicensePic: [],
        BankPic: [],
        BankProvince: null,
        BankCity: null,
        AreaId: null,
        DefaultSalesman: "",
        NewBankPic: [],
        ContactsIDPic: [],
        RetailPic: [],
        OrtherPic: [],
        AuditMsg: "",
        SaveType: 0,
        EditMark: 0,
        DangerWHPDate:''
      },
      formPersonal: {},
      rules: {
        Name: [
          {required: true,message: "请输入企业名称",trigger: "blur"},
          {max: 200,message: "长度不能超过 200 个字符",trigger: "blur"},
          // {
          //   validator: validateComname,
          //   trigger: 'blur'
          // }
        ],
        SimpleName: [
          {required: true,message: "请输入企业简称",trigger: "blur"},
          {max: 50,message: "长度不能超过 50 个字符",trigger: "blur"},
        ],DefaultSalesman: [
          {required: true,message: "请选择业务员",trigger: "change"},
        ],
        EnglishName: [
          {max: 500,message: "长度不能超过 500 个字符",trigger: "blur"},
        ],
        Code: [
          {max: 50,message: "长度不能超过 50 个字符",trigger: "blur"},
        ],
        Adress: [
          {required: true,message: "请输入开票地址",trigger: "blur"},
        ],
        BusinessLicense: [
          {required: true,message: "请输入统一社会信用代码",trigger: "blur"},
          // {
          //   validator: validateBusinessLicense,
          //   trigger: 'blur'
          // }
        ],
        JuridicalPerson: [
          {required: true,message: "请输入法人",trigger: "blur"},
          // {
          //   validator: validateJuridicalPerson,
          //   trigger: 'blur'
          // }
        ],
        DutyParagraph: [
          {required: true,message: "请输入税号",trigger: "blur"},
          // {
          //   validator: validateDutyParagraph,
          //   trigger: 'blur'
          // }
        ],
        OnlyBusinessLicense: [
          {required: true,message: "请选择三证合一",trigger: "change"},
        ],
        Phone: [
          {
            required: true,
            message: "请输入企业电话",
            trigger: "blur",
          },
          {
            validator: validatePhoneOrTel,
            trigger: "blur",
          },
        ],
        Fax: [
          {
            validator: validateFax,
            trigger: "blur",
          },
        ],
        ZipCode: [
          {
            validator: validateZipCode,
            trigger: "blur",
          },
        ],
        Area: [
          {max: 10,message: "长度不能超过 10 个字符",trigger: "blur"},
        ],
        ContactsIDPic: [
          {
            required:true,
            message:"请上传法人身份证!",
            trigger:"blur"
          }
        ],
        NewBankPic: [
          {
            required:true,
            message:"请上传开户许可证!",
            trigger:"blur"
          }
        ],
        Account: [
          {
            required: true,
            message: "请输入银行账号",
            trigger: "blur",
          }

        ],
        Bank: [{required: true,message: "请选择开户行",trigger: "change"}],
        Province: [{required: true,message: "请选择所属省份",trigger: "change"}],
        City: [{required: true,message: "请选择所属城市",trigger: "change"}],
        AreaId: [{required: true,message: "请选择所属区县",trigger: "change"}],
        BankProvince: [{required: true,message: "请选择开户省份",trigger: "change"}],
        BankCity: [{required: true,message: "请选择开户城市",trigger: "change"}],
        AccountBank: [{required: true,message: "请填写开户银行支行",trigger: "blur"}],//原先为下拉  改为手填 2021/11/19

        BusinessLicensePic: [
          {
            required: true,
            message: "请上传营业执照",
            trigger: "blur",
          },
        ],
        BusinessLicenseTime: [
          {
            required: false,
            message: "请输入营业执照有效期",
            trigger: "blur",
          },
        ],
        AccountBankTime: [
          {
            required: true,
            message: "请输入银行开户许可证有效期",
            trigger: "blur",
          },
        ],
        BankPic: [
          {
            required: false,
            message: "请上传危化品经营许可证",
            trigger: "blur",
          },
        ],
        MdmGoverFlag: [
          {
            required: true,
            message: "请选择机关企事业单位标识",
            trigger: "blur",
          },
        ],
      DangerWHPDate: [
        {
          required: false,
          message: "请选择危化品经营许可证有效期",
          trigger: "blur",
        },
      ],
      },
      Mdm: [
        {label: "是",value: true},
        {label: "否",value: false},
      ],
      formTemplatenew: [
        {col: 24,type: "tips",tips: "企业基本信息"},
        {col: 12,label: "企业名称",prop: "Name"},
        // {col: 12, label: '企业简称', prop: 'SimpleName'},
        // {col: 12, label: '英文名称', prop: 'EnglishName'},
        // { col: 12, label: '机关企事业单位', prop: 'MdmGoverFlag', type: 'select', options: [{label:'是',value:true},
        //     {label:'否',value:false}], filterable: true, default: false }, // 24
        {
          col: 12,label: "所属省份",prop: "Province",type: "select",options: [],change: () => {
            this.loadCity();
          },filterable: true,default: "",
        }, // 24
        {
          col: 12,label: "所属地级市",prop: "City",type: "select",options: [],change: () => {
          },filterable: true,default: "",
        }, // 25
        // { col: 12, label: '所属县区', prop: 'AreaId', type: 'select', options: [],filterable: true, default: '' }, // 25
        {col: 12,label: "开票地址",prop: "Adress"},
        {col: 12,label: "法人",prop: "JuridicalPerson"},
        {
          col: 12,label: "企业电话",prop: "Phone",change: (v) => {
            this.PhoneChange(v);
          },
        },
        // {
        //   col: 12, label: '传真', prop: 'Fax', change: (v) => {
        //     this.FaxChange(v)
        //   }
        // },
        // {
        //   col: 12, label: '邮编', prop: 'ZipCode', change: (v) => {
        //     this.ZipCodeChange(v)
        //   }
        // },
        //
        {col: 24,type: "tips",tips: "业务员"},
        {
          col: 24,label: "业务员",prop: "DefaultSalesman",type: "select",options: [],filterable: true,default: "",
        },

        {col: 24, type: 'tips', tips: '企业银行信息'},
        {col: 12,label: "开户银行",prop: "AccountBank"},
        {col: 12,label: "开户银行账号",prop: "Account"},
        // {
        //   col: 12, label: '开户省份', prop: 'BankProvince', type: 'select', options: [], change: () => {
        //     this.loadBankCity();
        //   }, filterable: true, default: ''
        // }, // 24
        // {col: 12, label: '开户地级市', prop: 'BankCity', type: 'select', options: [], filterable: true, default: ''}, // 25
        // {col: 24, label: '银行账号', prop: 'Account', default: ''}, // 26
        // {
        //   col: 24, label: '开户银行', prop: 'Bank', type: 'select', change: () => {
        //     this.loadBankBranch();
        //   }, options: [], filterable: true, default: ''
        // }, // 23
        // {col: 24, label: '开户银行支行', prop: 'AccountBank', clearable:true}, //原先为下拉  后改为手填

        {col: 24,type: "tips",tips: "企业附件"}, // 31
        {
          col: 24,label: "三证合一",prop: "OnlyBusinessLicense",type: "radio",
          options: [
            {label: "是",value: true},
            {label: "否",value: false},
          ],
          default: true,
        },
        {
          col: 24,label: "统一社会信用代码",prop: "BusinessLicense",change: (v) => {
            this.BusinessLicenseChange(v);
          }
          // ,cannotEidt: false,
        },
        {
          col: 24,label: "税务登记证编号",prop: "DutyParagraph",change: (v) => {
            // this.DutyParagraphChange(v)
          },showByProp: "OnlyBusinessLicense",showValue: false,
        },
        {
          col: 24,label: "组织机构代码",prop: "OrgCode",change: (v) => {
            // this.DutyParagraphChange(v)
          },showByProp: "OnlyBusinessLicense",showValue: false,
        },

        {col: 12,label: "营业执照有效期",type: "date",prop: "BusinessLicenseTime",default: "2099-12-31"},
        {
          col: 24,
          label: "营业执照",
          prop: "BusinessLicensePic",
          type: "picture-list",
          default: [],
          formIdProp: "Id",
          pictureType: "Enterprise",
          limit: 1,
        },
        { col:12, label:'危化品经营许可证有效期', type: 'date', prop:'DangerWHPDate' },
        {
          col: 24,
          // label: '银行开户许可证或委托书',
          label: "危化品经营许可证",
          prop: "BankPic",
          type: "picture-list",
          default: [],
          formIdProp: "Id",
          pictureType: "Enterprise",
          limit: 1,
        },
        {
          col: 24,
          label: "开户许可证",
          prop: "NewBankPic",
          type: "picture-list",
          default: [],
          formIdProp: "Id",
          pictureType: "Enterprise",
          limit: 1,
        },
        {
          col: 24,
          label: "法人身份证",
          prop: "ContactsIDPic",
          type: "picture-list",
          default: [],
          formIdProp: "Id",
          pictureType: "Enterprise",
          limit: 1,
        },
        // {
        //   col: 24,
        //   label: "成品油零售资质",
        //   prop: "RetailPic",
        //   type: "picture-list",
        //   default: [],
        //   formIdProp: "Id",
        //   pictureType: "Enterprise",
        //   limit: 1,
        // },
        {
          col: 24,
          label: "其他证件",
          prop: "OrtherPic",
          type: "picture-list",
          default: [],
          formIdProp: "Id",
          pictureType: "Enterprise",
          limit: 1,
        },
      ],
      url: {
        province: SZH.assets.api + "/Market/GetSelectProvince",
        city: SZH.assets.api + "/Market/GetSelectCity",
        GetSelectArea: SZH.assets.api + "/Market/GetSelectArea",
        bank: SZH.assets.api + "/Market/GetSelectBaseBank",
        bankBranch: SZH.assets.api + "/Market/GetSelectBankInfo",
        bankSearch: SZH.assets.api + "/Market/GetBankMapping",

        get: SZH.assets.api + "/Custom/GetSupplierListInfo",
        save: SZH.assets.api + "/Custom/SaveCustomEnterpriseNew",
        getCode: SZH.assets.api + "/Authen/GetCustomSAPNo",
        saveCommon: SZH.assets.api + "/Custom/SaveCustomRealName",
        VerifyCustomCompanyName: SZH.assets.api + "/Authen/VerifyCustomCompanyName",
        GetCompanyInfoNew: SZH.assets.api + "/Custom/GetSupplierInfo",
        UploadCompanyAuthInfo: SZH.assets.api + "/Custom/UploadSupplierAuthInfo",
        GetSelectSalesUser: SZH.assets.api + "/Custom/GetSelectSalesUserCG",
      },
      formChange: {
        Account: false, // 银行卡号
        BusinessLicense: false, // 营业执照
        JuridicalPerson: false, // 法人
        DutyParagraph: false, // 税号
        Phone: false, // 电话
        Fax: false, // 传真
        ZipCode: false, // 邮编
        ContactsEmail: false, // 联系人邮箱
      },
      state: [],
      isEdit: true,
      rowId: "",
      BindQualifications: [],//资质列表
      fullscreenLoading: false,
      isChange: false,
    };
  },
  methods: {
    changeCompany() {
      let self = this;
      self.isChange = true;
      self.formTemplatenew.forEach(item => {
        if (item.prop == "BusinessLicense") {
          item.cannotEidt = false;
        }
        if (item.prop == "BusinessLicensePic") {
          self.$nextTick(() => {
            self.form.BusinessLicensePic[0].Id = "0000";
          });
        }
        if (item.prop == "BankPic" && self.form.BankPic[0].Url) {
          self.$nextTick(() => {
            self.form.BankPic[0].Id = "0001";
          });
        }
        if (item.prop == "NewBankPic" && self.form.NewBankPic[0].Url) {
          self.$nextTick(() => {
            self.form.NewBankPic[0].Id = "0002";
          });
        }
        if (item.prop == "ContactsIDPic" && self.form.ContactsIDPic[0].Url) {
          self.$nextTick(() => {
            self.form.ContactsIDPic[0].Id = "0003";
          });
        }
        if (item.prop == "RetailPic" && self.form.RetailPic[0].Url) {
          self.$nextTick(() => {
            self.form.RetailPic[0].Id = "0004";
          });
        }
      });
    },
    BusinessLicenseLongTimeFlagChange(v) {
      if (v == true) {
        this.form.BusinessLicenseTime = "2099-01-01";
      } else {
        this.form.BusinessLicenseTime = null;
      }
    },
    ToNext(flag) {
      let self = this;
      self.$refs["form"].validate((valid) => {
        if (valid) {
          self.fullscreenLoading = true;
          self.form.EditMark = 0;
          self.form.SaveType = flag;
          self.$http.post(self.url.UploadCompanyAuthInfo,self.form).then(result => {
            if (result.state == true) {
              if (flag == 0) {
                self.$message.success("保存成功");
                location.reload();
              } else {
                self.$message.success("提交成功");
                self.$router.push({
                  path: "/My/companyFinished",
                });
              }


            } else {
              self.$message.error(result.message);
            }
            self.fullscreenLoading = false;
          },() => {
            self.fullscreenLoading = false;
          });
        } else {
          return false;
        }
      });

    },

    ToChange() {
      let self = this;
      self.$confirm("此操作将变更供应商信息,需要重新审批才可使用， 是否继续?","提示",{
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        self.$refs["form"].validate((valid) => {
          if (valid) {
            self.fullscreenLoading = true;
            self.form.EditMark = 1;
            self.$http.post(self.url.UploadCompanyAuthInfo,self.form).then(result => {
              if (result.state == true) {
                self.$message.success("变更成功");
                self.$router.push({
                  path: "/My/companyFinished",
                });
              } else {
                self.$message.error(result.message);
              }
              self.fullscreenLoading = false;
            },() => {
              self.fullscreenLoading = false;
            });
          } else {
            return false;
          }
        });
      }).catch(() => {
        self.$message({
          type: "info",
          message: "已取消变更",
        });
      });
    },
    formatDate(datetime) {
      return new Date(datetime).format("yyyy-MM-dd");
    },

    selectChange(v) {
      this.form.ContactCardId = null;
    },

    beforeSave() {
      this.uploading = true;
    },
    afterSaved() {
      this.uploading = false;
    },
    onSaved() {
      this.$message.success("保存成功");
      this.$router.push({
        path: "/My/Info",
      });
    },

    loadProvince() {
      var self = this;
      self.$http.post(self.url.province,{}).then(result => {
        for (let i in self.formTemplatenew) {
          if (self.formTemplatenew[i].prop == "Province" || self.formTemplatenew[i].prop == "BankProvince") {
            if (result.state == true && result.data != null) {
              self.formTemplatenew[i].options = result.data;
            } else {
              self.formTemplatenew[i].options = [];
            }
          }
        }
      },() => {
      });
    },
    //

    goBack() {
      this.$router.push({
        path: "/My/CompanyList",
      });
    },
    loadCity(v,flag) {
      var self = this;
      if (!flag) {
        self.form.City = null;
        self.form.AreaId = null;
      }
      self.$http.post(self.url.city,{KeyValue: self.form.Province}).then(result => {
        for (let i in self.formTemplatenew) {
          if (self.formTemplatenew[i].prop == "City") {
            if (result.state == true && result.data != null) {
              self.formTemplatenew[i].options = result.data;
            } else {
              self.formTemplatenew[i].options = [];
            }
          }
        }
      },() => {
      });
    },
    loadArea(v,flag) {
      var self = this;
      if (!flag) {
        self.form.AreaId = null;
      }
      self.$http.post(self.url.GetSelectArea,{KeyValue: self.form.City}).then(result => {
        for (let i in self.formTemplatenew) {
          if (self.formTemplatenew[i].prop == "AreaId") {
            if (result.State == 1 && result.Data != null) {
              self.formTemplatenew[i].options = result.Data;
            } else {
              self.formTemplatenew[i].options = [];
            }
          }
        }
      },() => {
      });
    },
    loadBankCity(v,flag) {

      var self = this;
      if (!flag) {
        self.form.BankCity = null;
      }
      self.$http.post(self.url.city,{KeyValue: self.form.BankProvince}).then(result => {
        for (let i in self.formTemplatenew) {
          if (self.formTemplatenew[i].prop == "BankCity") {
            if (result.state == true && result.data != null) {
              self.formTemplatenew[i].options = result.data;
            } else {
              self.formTemplatenew[i].options = [];
            }
          }
        }
      },() => {
      });
    },

    loadBanks() {
      var self = this;
      self.$http.post(self.url.bank,{KeyValue: self.form.BankProvince}).then(result => {
        for (var i in self.formTemplatenew) {
          if (self.formTemplatenew[i].prop == "Bank") {
            if (result.state == true && result.data != null) {
              self.formTemplatenew[i].options = result.data;
            } else {
              self.formTemplatenew[i].options = [];
            }
          }
        }
      },() => {
      });
    },
    GetSelectSalesUserFun() {
      var self = this;
      self.$http.post(self.url.GetSelectSalesUser,{}).then(result => {
        for (var i in self.formTemplatenew) {
          if (self.formTemplatenew[i].prop == "DefaultSalesman") {
            if (result.state == true && result.data != null) {
              self.formTemplatenew[i].options = result.data;
            } else {
              self.formTemplatenew[i].options = [];
            }
          }
        }
      },() => {
      });
    },
    loadBankBranch() {
      var self = this;
      if (self.form.BankCity != "" && self.form.BankCity != null && self.form.Bank != "" && self.form.Bank != null) {
        self.$http.post(self.url.bankBranch,{
          KeyValue: {
            BankId: self.form.Bank,
            CityId: self.form.BankCity,
          },
        }).then(result => {
        },() => {
        });
      }
    },
    ContactsEmailChange(v) { // 联系人邮箱
      this.formChange.ContactsEmail = true;
    },
    BusinessLicenseChange(v) { // 营业执照
      this.formChange.BusinessLicense = true;
      if (this.form.OnlyBusinessLicense) this.form.DutyParagraph = this.form.BusinessLicense;
    },
    JuridicalPersonChange(v) { // 法人
      this.formChange.JuridicalPerson = true;
    },
    DutyParagraphChange(v) { // 税号
      this.formChange.DutyParagraph = true;
    },
    PhoneChange(v) { // 电话
      this.formChange.Phone = true;
    },
    FaxChange(v) { // 传真
      this.formChange.Fax = true;
    },
    ZipCodeChange(v) { // 邮编
      this.formChange.Zip = true;
    },
    getCompanyInfo() {
      var self = this;
      self.boxLoading = true;
      self.$http.post(self.url.GetCompanyInfoNew,{
        KeyValue: self.rowId,
      }).then(result => {
        if (result.state == true && result.data != null) {
          for (let i in self.form) {
            for (let k in result.data) {
              if (i == k) {
                self.form[i] = result.data[k];
              }
            }
          }
          // 如果有rowId那么就要调用城市、支行接口
          if (result.data.Id) {
            self.loadCity("",true);
            self.loadBankCity("",true);
            self.loadBankBranch();
            // setTimeout(self.loadBankBranch(),500);
          }
        } else {
        }
        self.boxLoading = false;
      },() => {
        self.boxLoading = false;
      });
    },
  },
  created() {

  },
  mounted() {
    this.loadBanks();
    this.loadProvince();
    this.GetSelectSalesUserFun();
    this.$http.post(this.url.get, {}).then(result => {
      if (result.state == true && result.data) {
        this.rowId = result.data[0].Id;
        this.getCompanyInfo();
      }
    })
  },
  watch: {},
};



// WEBPACK FOOTER //
// ./src/views/Me/SupplierCertification/SupplierCertification.js